import React, { useEffect, useState } from 'react';
import './css/navbar.css';
import 'react-photo-view/dist/react-photo-view.css';
import NavBar from './components/NavBar';
import PageRoutes from './pages/PageRoutes';
import { actionUpdateKeyValue } from "./store/profile";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { apiRequest, API_CONSTANTS } from './libs/apiRequest';
import ReactGA from "react-ga4";
ReactGA.initialize("G-RKCNQYRFQX");

function App() {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const location = useLocation();
	const [profile, setProfile] = useState(null);
	const [currPath, setCurrPath] = useState('/');

	const checkAuth = async () => {
		try {
			const data = await apiRequest({
				method: "GET",
				api: API_CONSTANTS.PRIVATE_API,
				fn: "auth"
			});
			// console.log("checkAuth", data)
			if (data.status !== 200) {
				if (location.pathname != "/register" 
					&& location.pathname != "/login" 
					&& location.pathname != "/verify" 
					&& location.pathname != "/forgot"
					&& location.pathname != "/" 
					&& data.nextPath) {
					navigate(data.nextPath);
				} 
				else {
					if (location.pathname == "/register" 
						|| location.pathname == "/login" 
						|| location.pathname == "/verify" 
						|| location.pathname == "/forgot"
						|| location.pathname == "/") {
						
						if (location.pathname == "/") {
							navigate("/login");
							return;
						}	
						navigate(location.pathname);
						return;
					}
				}
			} else {
				setProfile(data);
				dispatch(actionUpdateKeyValue(data));

				if (location.pathname == "/register" 
					|| location.pathname == "/login" 
					|| location.pathname == "/verify" 
					|| location.pathname == "/forgot"
					|| location.pathname == "/") {

					navigate("/home");
					return;
				}
			}
		} catch (error) {
			console.log("checkAuth", error)
			navigate("/login");
		}
	}
	useEffect(() => {
		checkAuth();
	}, [])

	useEffect(() => {
		if (profile) {
			dispatch(actionUpdateKeyValue(profile));
		}
	}, [profile])


	useEffect(() => {
		const path = location.pathname;
		if (path != currPath) {
			ReactGA.send({ 
				hitType: "pageview", 
				page: location.pathname, 
				title: "GoTrycatch - Dashboard" 
			});
			setCurrPath(path);
		}
	})

	return (
		<>
			<NavBar />
			<div className="App">
				<PageRoutes />
			</div>
		</>
	);
}

export default App;
